<template>
<main class="main-wrapper flex-grow-1">
	<div class="d-flex align-items-center ">
			<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
					{{this.$t('1711')}}
			</div>
	</div>
	<div class="divider"></div>
	<!-- subtabs -->
<TopAppBarRewardListTab></TopAppBarRewardListTab>
<NoData v-if="isNoData" :type="myStatus"></NoData>
	<div class="container container--narrow mgt-30 pdr-1 mgb-50" else>
			<div class="d-grid-3-24">
        <div
          v-for="(badgeList, index) in listData"
          :key="index"
        >
          <!-- 목록 캠페인 카드 -->
          <ListItem :badgeList="badgeList" :myStatus="myStatus"></ListItem>
        </div>
      <infinite-loading
        @infinite="fetchData"
        :identifier="infiniteId"
        spinner="spiral"
      >
        <div slot="no-more" class="mgt-16"></div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
			</div>
	</div>
</main>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
// import { MDCRipple } from "@material/ripple";
import rewardApi from "@/api/rewardApi.js";
// import campaignApi from "@/api/campaignApi.js";
import ListItem from "./ListItem.vue";
import NoData from "../common/NoDataBadgeList.vue";
import TopAppBarRewardListTab from "../TopAppBarRewardListTab.vue";
import InfiniteLoading from "vue-infinite-loading";

export default {
	components: {
		ListItem,
		NoData,
		InfiniteLoading,
		TopAppBarRewardListTab
	},

	data() {
		return {
			status: "",
			isNoData: false,
			campaignData: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			mine: "",
			myStatus: "",
			infiniteId: +new Date(),
		};
	},

	computed: {},

	watch: {
		$route() {
			this.initData();
			this.myStatus = this.$route.query.status;
		},
	},

	mounted() {
		// 기본 파라미터 설정(set default parameter)
		if (!this.$route.query.status) {
			this.$router.push({ query: { status: "BADGE" } });
			this.myStatus = this.$route.query.status;
		} else {
			this.myStatus = this.$route.query.status;
		}
	},

	methods: {
		initData() {
			this.listData = [];
			this.currentPage = 1;
			this.totalPages = 1;
			this.infiniteId += 1;
		},
		// 목록 데이터 로딩(get list data)
		fetchData($state) {
			let responseData = null;
			let params = this.setParams();
			//console.log("params", params);
			if (this.totalPages >= this.currentPage) {
				rewardApi
					.rewardBadgeList(params)
					.then((response) => {
						responseData = response.data.data;
						//console.log('responseData=>',responseData);
						// this.mine = responseData.mine;

						this.listData = this.listData.concat(responseData.content);
						//console.log("listData=>", this.listData);
						this.currentPage++;
						this.totalPages = responseData.totalPages;

						if (responseData.content.length) {
							$state.loaded();
						} else {
							$state.complete();
						}

						//console.log("nodata", this.listData.length);
						if (this.listData.length > 0) {
							this.isNoData = false;
						} else {
							this.isNoData = true;
						}
					})
					.catch(() => {
						$state.error();
					});
			} else {
				$state.complete();
			}

		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				status: this.$route.query.status,   
				// name: "",
				// category: "",
				page: this.currentPage,
				size:10,
				sort: "id,desc",
			};
			return params;
		},
	},
};
</script>
